import Auth from './Auth';
import Admin from './Admin'
import Application from './Application';

const models = {
    application:Application,
    auth:Auth,
    admin:Admin,
}

export default models;